import React from "react";

const InputField = ({ label, placeholder, type, icon, onChange }) => {
  return (
    <div className="flex flex-col gap-1 items-start w-full">
      <label className="gap-1 w-full text-sm font-semibold leading-6 text-gray-700">
        {label}
      </label>
      <div className="flex gap-2 items-center w-full bg-gray-100 rounded-lg h-[38px] max-sm:h-11">
        <div className="flex gap-2 items-center px-3 py-2 rounded-lg flex-[1_0_0]">
          <input
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            className="flex-[1_0_0] bg-transparent text-sm leading-6 text-gray-700 outline-none placeholder:text-gray-400"
          />
          {icon && <div>{icon}</div>}
        </div>
      </div>
    </div>
  );
};

export default InputField;
